// store/authStore.js
import { create } from "zustand";
import Cookies from "js-cookie";
import { axiosInstance } from "../lib/axios";
import { useNavigate } from "react-router-dom";
import { checkAuthapi, loginapi, registeruser, resetpassword, updateuser } from "../api/auth";
import ResetPassword from "../screens/Auth/ResetPassword";

let globalNavigate = null;

export const setNavigator = (nav) => {
    globalNavigate = nav;
};

export const useAuthStore = create((set, get) => ({
    authUser: null,
    isSigningUp: false,
    isUpdatingProfile: false,
    isCheckingAuth: true,
    loading: false,
    hasTriedAuth: false,

    checkAuth: async () => {
        try {
            set({ loading: true })
            const res = await checkAuthapi()
            if (res) {
                set({ authUser: res })
            }
            set({ loading: false, hasTriedAuth: true })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    // LOGIN
    login: async (email, password) => {
        set({ isCheckingAuth: true, loading: true });

        try {
            const res = await loginapi(email, password)

            if (res?.accessToken)
                Cookies.set("accessToken", res?.accessToken, {
                    secure: true,
                    expires: 15 / (24 * 60),
                });

            if (res?.refreshToken)
                Cookies.set("refreshToken", res?.refreshToken, {
                    secure: true,
                    expires: 7,
                });

            set({ authUser: res?.user, isCheckingAuth: false, loading: false });

            // if (globalNavigate && typeof globalNavigate === "function") {
            //     globalNavigate("/");
            // }
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ isCheckingAuth: false });
            throw error;
        }
    },
    // LOGOUT
    logout: () => {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        set({ authUser: null });
        if (globalNavigate) globalNavigate("/login");
    },
    // REFRESH TOKEN
    refreshToken: async () => {
        try {
            const refreshToken = Cookies.get("refreshToken");
            const res = await axiosInstance.post("/auth/refresh", { refreshToken });

            const { accessToken } = res.data;
            Cookies.set("accessToken", accessToken, { secure: true });

            return accessToken;
        } catch (err) {
            console.error("Refresh token failed:", err);
            get().logout();
            throw err;
        }
    },
    registerUser: async (formData) => {
        try {
            set({ loading: true })
            const res = await registeruser(formData)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false })
            return false;
        } finally {
            set({ loading: false })
        }
    },
    updateUser: async (formData) => {
        try {
            set({ loading: true })
            const res = await updateuser(formData)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false })
            return false;
        } finally {
            set({ loading: false })
        }
    },
    resetPassword: async (formData) => {
        try {
            set({ loading: true })
            const res = await resetpassword(formData)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false })
            return false;
        } finally {
            set({ loading: false })
        }
    },

}));
